import { EmailEventType, EmailOffsetUnit, EmailSendRuleKind } from '@/types/touchPoint';
import { formatEventDateTime } from './dateTimeFormatters';
const ANCHOR_LABELS = {
    [EmailEventType.WebRegistered]: 'registration',
    [EmailEventType.OnlineEventStart]: 'event start',
    [EmailEventType.OnlineEventEnd]: 'event end',
    [EmailEventType.AssetDownloaded]: 'download',
    [EmailEventType.MeetingBooked]: 'meeting',
    [EmailEventType.DemoBooked]: 'demo',
};
const UNIT_LABELS = {
    [EmailOffsetUnit.Minute]: ['minute', 'minutes'],
    [EmailOffsetUnit.Hour]: ['hour', 'hours'],
    [EmailOffsetUnit.Day]: ['day', 'days'],
};
/**
 * Render an EmailSendRule as a humanized string for list views and editor previews.
 * Examples:
 *   "On registration"
 *   "5 days before event start"
 *   "1 hour after meeting"
 *   "Fires Tue, May 15, 9:00 AM PT"
 */
export function formatEmailRule(rule) {
    if (rule.Kind === EmailSendRuleKind.Scheduled) {
        if (!rule.SendAtAbsolute)
            return '—';
        return `Fires ${formatEventDateTime(rule.SendAtAbsolute)}`;
    }
    if (rule.Kind === EmailSendRuleKind.Event) {
        const { EventType, OffsetValue, OffsetUnit } = rule;
        if (!EventType || OffsetValue == null || !OffsetUnit)
            return '—';
        const anchorLabel = ANCHOR_LABELS[EventType];
        if (OffsetValue === 0) {
            return `On ${anchorLabel}`;
        }
        const abs = Math.abs(OffsetValue);
        const [singular, plural] = UNIT_LABELS[OffsetUnit];
        const unitLabel = abs === 1 ? singular : plural;
        const direction = OffsetValue < 0 ? 'before' : 'after';
        return `${abs} ${unitLabel} ${direction} ${anchorLabel}`;
    }
    return '—';
}
